module.exports = __webpack_public_path__ + "img/sulv_1.6e7ffd2c.jpg";